
import React, { Component } from 'react';
import { Card, Table, Alert, Spinner, Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { FaCheckCircle, FaFileAlt, FaFileInvoice, FaHourglassHalf, FaPencilAlt, FaTimesCircle } from "react-icons/fa";
import CommonTableModule from '../CommonTable/CommonTableModule';
import { DateTimeFormat } from '../DateFormat/DateTimeFormat';
import CommonDetailsForm from '../CommonAddressPage/CommonDetailsForm';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';
import { Modal } from "antd";
import { downloadCSV } from "../../utils/csvDownload";
import { hasPermission } from './../../utils/usePermission';
export default class MonthlySalary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthlySalary: [],
      financialInformations: [],
      loading: false,
      hasError: false,
      errMsg: "",
      showForm: false,
      selectedCustomer: null,
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      completed: false,
      color: '',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    };
  }

  async componentDidMount() {
    this.fetchData();
    this.fetchDataForSalaryInfo();
  }
  // start salary list

  fetchDataForSalaryInfo = () => {
    const { year, month } = this.state;
    axios({
      method: "get",
      url: `monthlySalary/csv/${year}/${month}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        this.setState({ financialInformations: res.data });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };
  // end
  fetchData = async () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('monthlySalary/list', { headers });

      console.log("response", response);
      this.setState({ monthlySalary: response?.data?.data, loading: false });
    } catch (error) {
      console.error("Error fetching monthly salary:", error);
      let errorMessage = "Failed to load monthly salary list.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }

  }


  handleClick = async (record) => {
    Modal.confirm({
      title: "Confirm Payment",
      content: `Are you sure you want to mark the salary for ${record.month} ${record.year} as paid?`,
      okText: "Yes, Pay",
      cancelText: "Cancel",
      onOk: () => this.processPayment(record),
    });
  };
  processPayment = async (record) => {
    this.setState({ loading: true });
    let salaryData = {
      year: record?.year,
      month: record?.month,
    };

    try {
      const res = await axios.post("/monthlySalary/change-status", salaryData);

      this.setState({
        completed: true,
        toastMessage: res?.data?.message,
        toastVariant: "success",
        color: "green",
        showToast: true,
      }, () => {
        if (this.state.completed) {
          downloadCSV(this.state.financialInformations, "Bank_Info");
        }
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 1000);

      this.fetchData();
    } catch (error) {
      let errorMessage = "Failed to pay salary.";

      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data.error || "Validation error!";
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }

      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: "Something went wrong!",
        toastVariant: "danger",
        color: "red",
        showToast: true,
      });

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 1000);
    }
  };

  render() {
    const { showForm, selectedCustomer } = this.state;

    const columns = [
      { key: "id", label: "ID" },
      { key: "year", label: "Year" },
      { key: "month", label: "Month" },
      { key: "total_number_of_payments", label: "No of Payment" },
      { key: "total_amount", label: "Total Amount" },

      {
        key: "generation_date",
        label: "Generated Date",
        render: (value) => DateTimeFormat(value),
      },
      {
        key: "payment_date",
        label: "Payment Date",
        render: (value) => value ? DateTimeFormat(value) : 'N/A',
      },
      {
        key: "status",
        label: "Status",
        // render: (value, record) => (
        //   <div className='address-div'>
        //     <Badge variant={value === "paid" ? "success" : "warning"}>{value.toUpperCase()}</Badge>
        //   </div>
        // ),
        render: rowData => {
          const status = rowData?.toLowerCase();
          const baseStyle = {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '0.875rem',
            padding: '4px 12px',
            borderRadius: '20px',
            fontWeight: 500
          };

          if (status === 'paid') {
            return (
              <span style={{
                ...baseStyle,
                backgroundColor: '#d1e7dd',
                color: '#0f5132',
                border: '1px solid #badbcc'
              }}>
                <FaCheckCircle /> Paid
              </span>
            );
          } else if (status === 'pending') {
            return (
              <span style={{
                ...baseStyle,
                backgroundColor: '#fff3cd',
                color: '#664d03',
                border: '1px solid #ffe69c'
              }}>
                <FaHourglassHalf /> Pending
              </span>
            );
          } else {
            return (
              <span style={{
                ...baseStyle,
                backgroundColor: "#f8d7da",
                color: '#842029',
                border: "1px solid #f5c2c7",
              }}>
                <FaTimesCircle /> Rejected
              </span>
            );
          }
        }
        // render: (rowData) => {
        //   console.log("after rowData", rowData);
        //   const status = rowData?.toLowerCase();
        //   const getStatusStyles = (status) => {
        //     switch (status) {
        //       case "paid":
        //         return {
        //           backgroundColor: "#E6F4EA",
        //           color: "#216e39",
        //           border: "1px solid #B6E2C5",
        //         };
        //       case "pending":
        //         return {
        //           backgroundColor: "#fff8e5",
        //           color: "#8a6d3b",
        //           border: "1px solid #ffe8a1",
        //         };
        //       case "rejected":
        //       default:
        //         return {
        //           backgroundColor: "#FBEAEA",
        //           color: "#A94442",
        //           border: "1px solid #F1B5B5",
        //         };
        //     }
        //   };

        //   const styles = {
        //     display: "inline-block",
        //     padding: "4px 12px",
        //     borderRadius: "20px",
        //     fontSize: "0.75rem",
        //     fontWeight: 600,
        //     textTransform: "uppercase",
        //     minWidth: "80px",
        //     textAlign: "center",
        //     ...getStatusStyles(status),
        //   };
        //   return <span style={styles}>{status}</span>;
        // }

      },
      {
        key: "",
        label: "Action",
        render: (value, record) =>
          record.status !== "paid" && ( // Only render if status is NOT "paid"
            <div className='address-div'>
              {hasPermission('M10S2B1') && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Pay Salary</Tooltip>}
                >
                  <Button
                    variant="outline-info"
                    size="sm"
                    className='address-btn info'
                    onClick={() => this.handleClick(record)}
                  >
                    <i className="fas fa-rupee-sign"></i>
                  </Button>

                </OverlayTrigger>
              )}
              {/* <Button
                variant="outline-primary"
                size="sm"
                className='address-btn'
                onClick={() => this.state.financialInformations.length > 0 && downloadCSV(this.state.financialInformations, "Bank_Info")}
                disabled={this.state.financialInformations.length === 0}
              // onClick={() => downloadCSV(this.state.monthlySalary, 'bankInfo')}
              >
                downloadCSV
              </Button> */}
            </div >
          ),
      },
    ];


    if (showForm && selectedCustomer) {
      return (
        <CommonDetailsForm
          useType="c"
          data={selectedCustomer}
          onClose={() => this.setState({ showForm: false })}
        />
      );
    }
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>

          <div className="container-fluid pt-4">
            <Card className="mb-3">
              <Card.Header>
                <b>Monthly Salary List</b>
              </Card.Header>
              <Card.Body>
                {/* {this.state.hasError ? (
                  <Alert variant="outline-danger" className="m-3">
                    {this.state.errMsg}
                  </Alert>
                ) : ( */}
                <CommonTableModule columns={columns} data={this.state.monthlySalary} />
                {/* )} */}
              </Card.Body>
            </Card>
          </div>
        </CommonLoader>
      </>
    );
  }
}
